// extracted by mini-css-extract-plugin
module.exports = {"input":"SimpleForm_input__2_pXv","last":"SimpleForm_last__2VJXP","form":"SimpleForm_form__3eTZ4"};